<div class="cashback">
  <p
    class="cashback__text"
    [ngStyle]="getTextStyles()"
    (mouseleave)="mouseEvent(false)"
    (mouseenter)="mouseEvent(true)"
    (touchend)="touchEvent()"
    #cashback
  >
    {{
      cashbackData.promotionFlag
        ? cashbackData.promotionFlag
        : "Cashback Aktion"
    }}
  </p>
  <app-popup
    [widthChild]="300"
    [sliderWrapper]="sliderWrapper"
    [parent]="cashback"
    *ngIf="popup?.['cashback'] && popup['cashback'] === cardId"
    (popupEvent)="popupEvent($event)"
  >
    <div class="cashback__popup">
      <h5 *ngIf="cashbackData.promotionHoverHeader" class="popup__title">
        {{ cashbackData.promotionHoverHeader }}
      </h5>
      <p *ngIf="cashbackData.promotionHoverText" class="popup__text">
        {{ cashbackData.promotionHoverText }}
      </p>
    </div>
  </app-popup>
</div>
